import { z } from 'zod';
export const updateWorkCategorySelectionSchema = z.object({
    keys: z.array(z.string()),
});
